import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../components/api";
import Modal from "react-bootstrap/Modal";

import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridFooterContainer,
  GridPagination,
} from "@mui/x-data-grid";
import AuthContext from "../context/AuthContext";
import FiberCoresEdit from "./FiberCoresEdit";
import ExcelSVG from "../../ExcelSVG.svg";
import FilterSVG from "../../FilterSVG.svg";
import Button from "react-bootstrap/Button";
import * as XLSX from "xlsx";
// For API Requests
import axios from "axios";

function FiberCoresTable() {
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const handleshowDetails = () => setShow(true);
  const handlecloseDetails = () => setShow(false);
  const { user } = useContext(AuthContext);
  const [code, setCode] = useState("");

  const [selectedCoreId, setSelectedCoreId] = useState(null);
  const [subscriptions, setSubscriptions] = useState([]);
  const [showSubscriptions, setShowSubscriptions] = useState(false);

  const authTokens = JSON.parse(localStorage.getItem("authTokens"));

  const [Details, setDetails] = useState({
    core_id: 0,
    code: "",
    sticker: "",
    type: "",
    status: "",
    mgrs: "",
    map: "",
    fiber_meters: 0,
    parent_core: "",
  });
  const [filters, setFilters] = useState({
    core_id: "",
    code: "",
    sticker: "",
    type: "",
    status: "",
    mgrs: "",
    map: "",
    fiber_meters: "",
  });
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [gridFilterModel, setGridFilterModel] = useState({
    items: [],
  });

  const [searchInput, setSearchInput] = useState(""); // To capture search input

  // NEW: State to track column visibility
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
  const [searchFilterTimeout, setSearchFilterTimeout] = useState(null);

  const updateDetails = (details) => {
    setDetails(details);
  };
  const fetchData = async () => {
    try {
      const response = await axios.get(`${API_URL}/radius/fiber/cores/`, {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
        params: {
          username: user.username,
        },
      });

      if (response.status === 200) {
        setData(response.data.reverse());
        console.log(response.data.reverse());
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [user.username, authTokens.access]);

  // Fetch Subscriptions Data for a Core
  const fetchSubscriptions = async (coreId) => {
    try {
      const response = await axios.get(
        `${API_URL}/radius/fiber/cores/subscription/`,
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: { username: user.username, core_id: coreId },
        }
      );

      if (response.status === 200) {
        setSubscriptions(response.data);
        setShowSubscriptions(true);
      }
    } catch (error) {
      console.error("Failed to fetch subscriptions:", error);
    }
  };

  const columns = [
    { field: "code", headerName: "Name", flex: 2, minWidth: 150 },
    { field: "status", headerName: "Status", flex: 2, minWidth: 150 },
    { field: "parent_core", headerName: "Parent", flex: 2, minWidth: 150 },
    { field: "sticker", headerName: "Sticker", flex: 2, minWidth: 150 },

    {
      field: "mgrs",
      headerName: "Location",
      minWidth: 230,
    },
    {
      field: "map",
      headerName: "Map",
      minWidth: 150,
    },
    { field: "fiber_meters", headerName: "Fiber Meters", minWidth: 150 },
    {
      field: "type",
      headerName: "Type",
      minWidth: 100,
    },
    {
      field: "zone_name",
      headerName: "Zone",
      minWidth: 150,
    },
    { field: "subscription_count", headerName: "Subscriptions", minWidth: 150 },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 230,
      flex: 2,
      renderCell: (params) => (
        <div>
          <button
            className="edit-client"
            onClick={() => {
              const Details = {
                core_id: params.row.core_id,
                code: params.row.code,
                mgrs: params.row.mgrs,
                status: params.row.status,
                type: params.row.type,
                sticker: params.row.sticker,
                map: params.row.map,
                fiber_meters: params.row.fiber_meters,
                parent_core: params.row.parent_core,
              };
              updateDetails(Details);
              setCode(params.row.code);
              handleshowDetails();
            }}
          >
            Edit
          </button>
          <button
            className="view-subscriptions"
            onClick={() => fetchSubscriptions(params.row.core_id)}
          >
            Subscriptions
          </button>
        </div>
      ),
    },
  ];

  const getRowId = (row) => row.core_id;

  // Create a delayed search filter function
  const delaySearchFilter = (input) => {
    setSearchQuery(input);
  };

  useEffect(() => {
    // Save "searchValue" value before clearing other session storage items
    const searchValue = sessionStorage.getItem("searchFiberCores");

    // Clear all session storage items except "searchValue"
    Object.keys(sessionStorage).forEach((key) => {
      if (key !== "searchFiberCores") {
        sessionStorage.removeItem(key);
      }
    });

    // Restore "searchValue" value if needed
    if (searchValue) {
      sessionStorage.setItem("searchFiberCores", searchValue);
      setSearchQuery(searchValue);
    }
  }, []);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchInput(query);
    sessionStorage.setItem("searchFiberCores", query);

    if (searchFilterTimeout) {
      clearTimeout(searchFilterTimeout);
    }

    const newTimeout = setTimeout(() => {
      delaySearchFilter(query);
    }, 100);
    setSearchFilterTimeout(newTimeout);
  };

  // IMPROVED: Combined filtering logic that works for both display AND export
  const filteredRows = data.filter((row) => {
    // Apply search query filter
    const searchMatch = searchQuery
      .split(" ")
      .every((word) =>
        Object.values(row).some((value) =>
          String(value).toLowerCase().includes(word.toLowerCase().trim())
        )
      );

    // Apply modal filters
    const modalFilterMatch = Object.keys(filters).every((key) => {
      if (!filters[key]) return true;

      if (key === "connectivity_dependent") {
        const filterValue = filters[key].toLowerCase();
        if (row.connectivity === "Fiber") {
          return (row.code || "").toLowerCase().includes(filterValue);
        } else if (row.connectivity === "Wireless") {
          return (row.name || "").toLowerCase().includes(filterValue);
        }
        return false;
      }

      const rowValue = String(row[key] || "").toLowerCase();
      const filterValue = String(filters[key]).toLowerCase();
      return rowValue.includes(filterValue);
    });

    // Apply DataGrid filters
    const gridFilterMatch = gridFilterModel.items.every((filterItem) => {
      if (!filterItem.value) return true;

      const cellValue = row[filterItem.field];
      const filterValue = filterItem.value;

      switch (filterItem.operator) {
        case "contains":
          return String(cellValue || "")
            .toLowerCase()
            .includes(String(filterValue).toLowerCase());
        case "equals":
          return String(cellValue || "") === String(filterValue);
        case "startsWith":
          return String(cellValue || "")
            .toLowerCase()
            .startsWith(String(filterValue).toLowerCase());
        case "endsWith":
          return String(cellValue || "")
            .toLowerCase()
            .endsWith(String(filterValue).toLowerCase());
        default:
          return true;
      }
    });

    return searchMatch && modalFilterMatch && gridFilterMatch;
  });

  const handleFilterChange = (field, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [field]: value,
    }));
  };

  const columnHeaders = {
    code: "Name",
    status: "Status",
    parent_core: "Parent",
    sticker: "Sticker",
    mgrs: "Location",
    map: "Map",
    fiber_meters: "Fiber Meters",
    type: "Type",
    owner_name: "Building",
  };

  // Format date fields properly for export — e.g. "21/02/2025 10:25:52 AM"
  const formatDateForExport = (dateValue) => {
    if (!dateValue) return "";
    const date = new Date(dateValue);

    // Format as DD/MM/YYYY HH:MM:SS AM/PM
    const formattedDate = date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    // Ensure consistent spacing before AM/PM
    return formattedDate.replace(" am", " AM").replace(" pm", " PM");
  };

  /// Corrected: Transform rows respecting column visibility
  const transformRowsForExport = (rows) => {
    return rows.map((row) => {
      const transformedRow = {};

      Object.keys(columnHeaders).forEach((field) => {
        // Only export if column is visible
        if (columnVisibilityModel[field] !== false) {
          const headerName = columnHeaders[field];

          // Default: use the value or empty string
          transformedRow[headerName] = row[field] ?? "";
        }
      });

      return transformedRow;
    });
  };

  // IMPROVED: Export function that uses the already-filtered rows
  const handleExportToExcel = () => {
    console.log("Exporting data...");
    console.log("Total data rows:", data.length);
    console.log("Filtered rows:", filteredRows.length);
    console.log("Active filters:", {
      search: searchQuery,
      modalFilters: filters,
      gridFilters: gridFilterModel.items,
    });
    console.log("Column visibility:", columnVisibilityModel);

    // Always use filteredRows which has ALL filters applied
    const transformedRows = transformRowsForExport(filteredRows);

    console.log("Rows to export:", transformedRows.length);

    const worksheet = XLSX.utils.json_to_sheet(transformedRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Fiber Cores");
    XLSX.writeFile(workbook, "Fiber Cores.xlsx");
  };

  const [isPressed, setIsPressed] = useState(false);

  const handleExportClick = () => {
    setIsPressed(true);
    handleExportToExcel();
    setTimeout(() => {
      setIsPressed(false);
    }, 200);
  };

  const CustomToolbar = () => (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <Button
        onClick={() => setShowFilterModal(true)}
        variant="outline-primary"
        style={{
          border: "none",
        }}
      >
        <img
          src={FilterSVG}
          alt="Filter Icon"
          style={{
            color: "white",
            width: "18px",
            marginRight: "8px",
            filter: "invert(0)", // keep black icon
          }}
        />
        Filter
      </Button>
      {/*<GridToolbarFilterButton />*/}
      <GridToolbarExport />
      <Button
        onClick={handleExportClick}
        variant="outline-success"
        style={{
          display: "flex",
          alignItems: "center",
          padding: "5px 10px",
          fontSize: "14px",
          border: "none",
          backgroundColor: isPressed ? "white" : "transparent",
          color: isPressed ? "black" : "#007bff",
          cursor: "pointer",
        }}
      >
        <img
          src={ExcelSVG}
          alt="Excel Icon"
          style={{
            width: "20px",
            marginRight: "8px",
            filter: isPressed ? "invert(0)" : "invert(1)",
          }}
        />
        Excel
      </Button>
    </GridToolbarContainer>
  );

  const CustomFooter = () => (
    <GridFooterContainer>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: "10px",
        }}
      >
        <GridPagination />
      </div>
    </GridFooterContainer>
  );

  return (
    <div className="ClientTable">
      <style>{`
        .MuiDataGrid-panelWrapper {
          background: #122632 !important;
        }
      `}</style>
      <input
        type="text"
        placeholder="Search..."
        value={searchInput}
        onChange={handleSearchChange}
        className="search-client"
      />
      {!loading && data.length > 0 && (
        <div style={{ height: 520, width: "100%" }}>
          <DataGrid
            rows={filteredRows}
            columns={columns}
            getRowId={getRowId}
            filterModel={gridFilterModel}
            onFilterModelChange={(newModel) => setGridFilterModel(newModel)}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
            components={{
              Footer: () => <CustomFooter />,
              Toolbar: CustomToolbar,
            }}
            rowsPerPageOptions={[10, 100, 1000]}
            pagination
            disableSelectionOnClick
          />
        </div>
      )}
      <Modal show={showFilterModal} onHide={() => setShowFilterModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Filters</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {columns
            .filter((col) => col.field !== "actions")
            .map((col) => (
              <div key={col.field} className="filter">
                <label>{col.headerName}</label>
                <input
                  type="text"
                  placeholder={`Filter by ${col.headerName}`}
                  value={filters[col.field] || ""}
                  onChange={(e) =>
                    handleFilterChange(col.field, e.target.value)
                  }
                  className="filter-input"
                />
              </div>
            ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowFilterModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={show} onHide={handlecloseDetails} className="modal-lg">
        <Modal.Header closeButton>
          <Modal.Title>Edit Core {code}</Modal.Title>
        </Modal.Header>
        <div className="Subform">
          <FiberCoresEdit
            type={Details.type}
            code={Details.code}
            core_id={Details.core_id}
            mgrs={Details.mgrs}
            status={Details.status}
            sticker={Details.sticker}
            map={Details.map}
            meters={Details.fiber_meters}
            parent_core={Details.parent_core}
            closeModal={handlecloseDetails}
            fetch={fetchData}
          />
        </div>
      </Modal>
      {/* Subscriptions Modal */}
      <Modal
        show={showSubscriptions}
        onHide={() => setShowSubscriptions(false)}
        className="modal-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Subscriptions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {subscriptions.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th>Username</th>
                  <th>Full Name</th>
                  <th>Plan Name</th>
                  <th>Consumption Option</th>
                </tr>
              </thead>
              <tbody>
                {subscriptions.map((sub, index) => (
                  <tr key={index}>
                    <td>{sub.username}</td>
                    <td>{sub.full_name}</td>
                    <td>{sub.plan_name}</td>
                    <td>{sub.consumption_option}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No subscriptions found.</p>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default FiberCoresTable;
